module.exports = __webpack_public_path__ + "static/hugh_fadal_band-5873cc792639c0cfd8b42c01b528306d.jpg";